<template>
  <div class="kw_change_look">
    <span @click="openChangeDialog" >
        {{initData.fieldCnName}}:{{initData.defaultValStr}}
    </span>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
export default {
  name: 'kw_change_look',
  props: {
    initData:{
      type:Object,
      default:{}
    },
    nowDataId:{
      type: Number,
      default: 0
    }
  },
  data() {
    return {
    };
  },
  created() {
    
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
  },
  methods: {
    /**
     * 点击时 进行关联的页面打开
     */
    openChangeDialog(){
      var filedInfo = this.initData;
      var clickPageId = filedInfo.styleSet.clickPageId;
      var clickTableId = filedInfo.styleSet.clickTableId;
      if (filedInfo.pageDialog > 0) {
        clickPageId = filedInfo.pageDialog
      } 
      if (filedInfo.relationTableId > 0) {
        clickTableId = filedInfo.relationTableId
      }
      var toListJson = {
        pageId: clickPageId,
        tableId: clickTableId,
        initCheckId: this.data.nowDataId,
        callBackType: 2,
        dataMaxNum: filedInfo.dataMaxNum
      }
      pageUtils.toNewListPage(this,toListJson);
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
